export default new Promise((resolve, reject) => {
    resolve(true);
});
